import { ref } from '@vue/composition-api'
import { STORE_MODULE_NAME } from "./stationStoreModule";

export default function useStation() {

    // Table Handlers
  const tableColumns = ref([
      { key: 'station',
        label: 'станция',
      },
      { key: 'railway_sector',
        label: 'сектор',
      },
      { key: 'user',
        label: 'пользователь',
      },
  ])

  const setupData = {
      formModel: {
          name:'',
          number: '',
          railway_sector: '',
          user: '',
          geolocation: {
              point: {
                  lat: null,
                  long: null
              },
              geo_addition: {
                  picket: null,
                  km: null,
                  path: null
              }
          }
      },
  }

  const addDataUrl = `${STORE_MODULE_NAME}/create`
  const fetchDataUrl = `${STORE_MODULE_NAME}/fetch`

  return {

    addDataUrl,
    fetchDataUrl,

    tableColumns,
    setupData,
  }
}
